import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IParamsType } from '@/utils/ctype';
import { getExamInfo, IGetExamInfo } from '@/api/start';

export interface IExam {
  info: IGetExamInfo | null;
}

const initialState: IExam = {
  info: null,

};

export const getExamInfoAsync = createAsyncThunk<IGetExamInfo | undefined, IParamsType>('exam/getExamInfoAsync', async (params, {rejectWithValue, getState}) => {
  try {
    const res = await getExamInfo(params);
    if (res.code !== 200) {
      return rejectWithValue(null);
    }
    return res.data;
  } catch (err) {
    return rejectWithValue(null);
  }
});

export const examSlice = createSlice({
  name: 'exam',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getExamInfoAsync.fulfilled,(state, {payload})=>{
      if (payload) {
        state.info = payload;
      }
    });
  },
});